import { ReactComponent as IconChevronRight } from '@/assets/svgs/chevron-right.svg';
import { ReactComponent as IconUseCase } from '@/assets/svgs/icon-use-cases.svg';
import classname from 'classnames';
import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';
import { useState } from 'react';

const DataElementCard = ({ useCaseItem }) => {
	const [dataElementExpand, setDataElementExpand] = useState(false)
	const [participantExpand, setParticipantExpand] = useState(false)

	const dataElementArrowAction = classname({
		'enrolment-request-field-action': true,
		'enrolment-request-field-action--active ': dataElementExpand
	})

	const participantArrowAction = classname({
		'enrolment-request-field-action': true,
		'enrolment-request-field-action--active': participantExpand
	})

	const useCaseItemObj = Array.isArray(useCaseItem) ? useCaseItem[0] : useCaseItem;

	return <div className="layout-request__tile__content">
		<div className="layout-request__tile__content__header request-enrolment-confirmation-header">
			<div className="layout-request__title__content__header__left">
				<div className="request-title request-enrolment-confirmation-header-title">
					Selected Use Case
				</div>
			</div>
		</div>
		<div className="enrolment-request__tile__content">
			<div className=" enrolment-request__tile__content__sub__header">
				<div className="request-enrolment-admin__confirmation-tile__sub-header__icon confirmation-tile__use-case-icon">
					<IconUseCase />
				</div>
				<div className="request-enrolment-admin__confirmation-tile__sub-header__title ">{useCaseItemObj?.name}</div>
				<div className="request-enrolment-admin__confirmation-tile__sub-header__description">{useCaseItemObj?.description}</div>
			</div>
			<div className="layout-request__tile__content__sub__header enrolment-request__tile__content__sub__header">
				<div className="enrolment-request__tile__content__sub__header__text">
					<div className="layout-request__tile__content__sub__header__text__top">
						<div className="layout-request__tile__content__sub__header__text__top__left">
							<div className="request-title-sub__text--link">
								<span>Data Elements</span>
							</div>
						</div>
						<div className="layout-request__tile__content__sub__header__text__top__right">
							<span className="enrolment-request-field-count">
								{useCaseItemObj?.dataElements.length}
							</span>
							<span className={dataElementArrowAction} onClick={() => setDataElementExpand(!dataElementExpand)}>
								<IconChevronRight />
							</span>
						</div>
					</div>
					<div className="enrolment-request__tile__content__sub__header__text__bottom">
						{
							dataElementExpand && useCaseItemObj?.dataElements.map((item, index) => (
								<div className="layout-card__content_row" key={uniqueId()}>
									<div className="layout-card__content__text">
										{item.name}
									</div>
								</div>
							))
						}
					</div>
				</div>
			</div>
			<div className="layout-request__tile__content__sub__header enrolment-request__tile__content__sub__header">
				<div className="enrolment-request__tile__content__sub__header__text">
					<div className="layout-request__tile__content__sub__header__text__top">
						<div className="layout-request__tile__content__sub__header__text__top__left">
							<div className="request-title-sub__text--link">
								<span>Participants</span>
							</div>
						</div>
						<div className="layout-request__tile__content__sub__header__text__top__right">
							<span className="enrolment-request-field-count">
								{useCaseItemObj?.participants}
							</span>
							<span className={participantArrowAction} onClick={() => setParticipantExpand(!participantExpand)}>
								<IconChevronRight />
							</span>
						</div>
					</div>
					<div className="enrolment-request__tile__content__sub__header__text__bottom">
						{
							participantExpand && useCaseItemObj?.enrolledParticipants.map((item, index) => (
								<div className="layout-card__content_row" key={uniqueId()}>
									<div className="layout-card__content__text">
										{item.name}
									</div>
								</div>
							))
						}
					</div>
				</div>
			</div>
		</div>
	</div>
};

DataElementCard.propTypes = {
	useCaseItem: PropTypes.array.isRequired
}

export default DataElementCard;
